import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/WechatIMG6281.jpg'


const _withScopeId = n => (_pushScopeId("data-v-27854f7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode("活动编辑器")
], -1))
const _hoisted_2 = {
  href: "tencent://message/?uin=815612109",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"max-width":"400px"},
  alt: ""
}, null, -1))

import {useRouter} from "vue-router";
import {
  CheckOutlined,
  LogoutOutlined,
  SaveOutlined,
  PlusOutlined,
  QqOutlined,
  WechatOutlined, CloseOutlined
} from "@ant-design/icons-vue";
import LogoView from "@/components/LogoView.vue";
import {editor} from "@/app/editor/index";
import {IconFont} from "@/lib/util";
import {onMounted, onUnmounted, reactive, watch} from "vue";
import PurchaseBox from "@/components/views/PurchaseBox.vue";
import {account} from "@/app/login";
import emit from "@/lib/emit";
import {message} from "ant-design-vue";
import PopupBase from "@/components/PopupBase.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorMenu',
  setup(__props) {

const router = useRouter()
const info = reactive({isEdit: false, buy: {open: false}, expIndex: 0, isActive: false, reg: false})
const onExit = () => router.go(-1)
const onSave = () => {
  editor.activity?.save(() =>{
    //
  })
}

onMounted(() => {
  emit.on('editor.activity.loaded', () => {
    info.isActive = editor.activity?.data.is_active ?? false
    info.isEdit = editor.activity?.isEdit() ?? false
    if (!info.isEdit && account.exp_packages.length)
      editor.activity?.useExpPackage(account.exp_packages[0].exp_package_id)

    // console.log('watch editor.activity?.data.is_active', editor.activity?.data.is_active)
    watch(() => editor.activity?.data.is_active, is_active => {
      console.log('event is active:', is_active)
      info.isActive = is_active ?? false
    })
  })
  watch(() => info.expIndex, i => {
    editor.activity?.useExpPackage(account.exp_packages[i].exp_package_id)
  })
})

onUnmounted(() => {
  emit.off('editor.activity.loaded')
})

const offline = () => {
  const l = message.loading('操作中', 0)
  editor.activity?.offline(l)
}

const onlineAndSave = () => {
  if (editor.activity) {
    editor.activity.data.is_active = true
    editor.activity?.save(() =>{
      if (editor.activity) editor.activity.data.is_active = false
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown_button = _resolveComponent("a-dropdown-button")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LogoView),
    _hoisted_1,
    _createVNode(_component_a_flex, {
      gap: "10",
      style: {"padding-right":"24px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "large",
          onClick: onExit,
          danger: ""
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(LogoutOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 退出编辑 ")
          ]),
          _: 1
        }),
        (_unref(account).user?.is_master)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (info.isActive)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_a_button, {
                      size: "large",
                      type: "primary",
                      danger: "",
                      ghost: "",
                      onClick: offline
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下架")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      size: "large",
                      type: "primary",
                      onClick: onSave
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("更新")
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "large",
                    type: "primary",
                    onClick: onlineAndSave
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存并上架")
                    ]),
                    _: 1
                  }))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_unref(editor).activity?.isEdit())
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    size: "large",
                    type: "default",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor).activity?.saveDraft()))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(IconFont), { type: "icon-draft" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 保存为草稿 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!info.isEdit)
                ? (_openBlock(), _createBlock(_component_a_dropdown_button, {
                    key: 1,
                    size: "large",
                    type: "default"
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account).exp_packages, (c, i) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: i,
                              onClick: ($event: any) => (info.expIndex=i)
                            }, {
                              icon: _withCtx(() => [
                                (i == info.expIndex)
                                  ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(c.title) + " (余:" + _toDisplayString(c.balance) + "次) ", 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128)),
                          _createVNode(_component_a_menu_divider, { type: "divider" }),
                          _createVNode(_component_a_menu_item, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (info.buy.open = true))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(IconFont), { type: "icon-goumai" })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" 购买活动服务包 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(account).exp_packages.length ? `${_unref(account).exp_packages[info.expIndex].title} (余:${_unref(account).exp_packages[info.expIndex].balance}次)` : '无活动服务包') + " ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                size: "large",
                type: "primary",
                onClick: onSave
              }, {
                icon: _withCtx(() => [
                  (info.isEdit)
                    ? (_openBlock(), _createBlock(_unref(SaveOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 }))
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(info.isEdit ? '保存' : '创建'), 1)
                ]),
                _: 1
              })
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(PurchaseBox, {
      open: info.buy.open,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((info.buy.open) = $event))
    }, null, 8, ["open"]),
    _createVNode(_component_a_flex, {
      vertical: "",
      class: "contact-us",
      gap: "middle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_a_button, {
            shape: "circle",
            size: "large"
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(QqOutlined))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_button, {
          shape: "circle",
          size: "large",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (info.reg=true))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(WechatOutlined))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(PopupBase, {
      open: info.reg,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((info.reg) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CloseOutlined), {
          style: {"position":"absolute","top":"14px","right":"14px","color":"white"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (info.reg=false))
        }),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})